exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saveQuestionModalFields {\n  overflow: hidden;\n}\n\n.saveQuestionModalFields-enter {\n  max-height: 0px;\n}\n\n.saveQuestionModalFields-enter.saveQuestionModalFields-enter-active {\n  /* using 100% max-height breaks the transition */\n  max-height: 300px;\n  transition: max-height 500ms ease-out;\n}\n\n.saveQuestionModalFields-leave {\n  max-height: 300px;\n}\n\n.saveQuestionModalFields-leave.saveQuestionModalFields-leave-active {\n  max-height: 0px;\n  transition: max-height 500ms ease-out;\n}\n", ""]);

// exports
